module.exports = __webpack_public_path__ + "img/pcStu.ba8d9fd5.png";